import { Component, ViewChild } from '@angular/core';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { ApiService } from '../../../../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Voucher } from '../../../../shared/interface';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-modifica-voucher-backoffice',
  templateUrl: './modifica-voucher-backoffice.component.html',
  styleUrl: './modifica-voucher-backoffice.component.css'
})
export class ModificaVoucherBackofficeComponent {

  @ViewChild("confirmDeletePopupRef") confirmPopup!: ConfirmPopup;

  constructor(private apiService: ApiService, private router: Router, private route: ActivatedRoute, private confirmationService: ConfirmationService, private datePipe: DatePipe) { }  

  formVoucher!: FormGroup;  

  voucher?: Voucher;

  minDate: Date | undefined = new Date();

  ngOnInit(): void {    

    this.formVoucher = new FormGroup({
      cliente: new FormControl(null, Validators.required),      
      email: new FormControl(null, Validators.email),      
      telefono: new FormControl(null),
      codice: new FormControl(null, Validators.required),
      credito: new FormControl(null, Validators.required),
      data_scadenza: new FormControl(null),
    })

    this.route.params.subscribe(params => {
      const id = params['id'];

      this.apiService.getVoucher(id).subscribe({
        next: (data) => this.voucher = data,
        error: (err) => this.router.navigate(['/backoffice/vouchers']),
        complete: () => {

          this.formVoucher.patchValue({
            cliente: this.voucher?.cliente,
            email: this.voucher?.email,
            telefono: this.voucher?.telefono,
            codice: this.voucher?.codice,
            credito: this.voucher?.credito,
            data_scadenza: new Date(this.voucher!.data_scadenza),
          })

        }
      })

    })
  }

  onDeleteVoucherPopup(event: Event) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler eliminare il voucher?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteVoucher(this.voucher!.id).subscribe({
          next: (data) => this.apiService.setVouchers(),
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.router.navigate(['/backoffice/vouchers']);
            this.apiService.message("success", "Eliminazione", "Il voucher è stato eliminato con successo!")
          }
        })
      }
    });
  }

  onDelete() {
    this.confirmPopup.accept();
  }

  onAnnulla() {
    this.confirmPopup.reject();
  }

  onSubmit() {

    const voucher = {
      cliente: this.formVoucher.get('cliente')?.value,
      email: this.formVoucher.get('email')?.value,
      telefono: this.formVoucher.get('telefono')?.value,      
      credito: this.formVoucher.get('credito')?.value,
      codice: this.formVoucher.get('codice')?.value,
      data_scadenza: this.datePipe.transform(this.formVoucher.get('data_scadenza')?.value, 'yyyy-MM-dd'),
    }

    this.apiService.updateVoucher(voucher, this.voucher!.id).subscribe({
      next: (data) => this.apiService.setVouchers(),        
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/vouchers'])
        this.apiService.message('success', 'Modifica', "Modifica effettuata con successo!")
      }
    })

  }
  

}
